// extracted by mini-css-extract-plugin
export default {"dogsArea":"Dogs_dogsArea__dqpNA","showCards":"Dogs_showCards__tmHf2","paginate":"Dogs_paginate__1lgk5"};